/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */

export type ContractsControllerListV1Quick = typeof ContractsControllerListV1Quick[keyof typeof ContractsControllerListV1Quick];


export const ContractsControllerListV1Quick = {
  all: 'all',
  negotiation: 'negotiation',
  signature: 'signature',
  active: 'active',
  expiring: 'expiring',
} as const;
